import { http } from '../../pixel/index';
import { formatMoney } from '../../components/cart/utils.js';
import IFinancingProvider from './IFinancingProvider';
import { openModal } from '@/components/commons/Dialog/Dialog.vue';
import { defineAsyncComponent } from 'vue';

export default {
  load(key, url, _options) {
    if (window['paybrightConfig']) {
      return;
    }
    window['paybrightConfig'] = {
      key,
      url,
      modalUrl: _options.paybrightModalUrl,
    };
  },

  async estimatePayment(amountInCents, financingconfig, options) {
    this.load(financingconfig.paybrightKey, financingconfig.paybrightUrl, financingconfig);
    return new Promise((resolve, reject) => {
      try {
        const formattedAmount = formatMoney('', amountInCents);
        this.fetchEstimate(formattedAmount).then((data) => {
          const modalUrl = this.modalUrl(formattedAmount);
          const openEstimateModal = this.openModalForAmount.bind(this, formattedAmount);
          resolve({
            provider:"pb",
            estimateAvailable: true,
            monthlyPayment: data?.monthlyPayment,
            modalUrl,
            openNativeModal: openEstimateModal,
            openModal: openEstimateModal,
          });
        });
      } catch (error) {
        console.error(error);
        resolve({
          provider:"pb",
          estimateAvailable: false,
          monthlyPayment: null,
          modalUrl: this.modalUrl(),
          openNativeModal: this.openModalForAmount,
          openModal: this.openModalForAmount,
        });
      }
    });
  },

  openModalForAmount(amount) {
    return this.openModalForUrl(this.modalUrl(amount));
  },

  openModalForUrl(url) {
    return openModal(
      defineAsyncComponent(() => import('@/components/commons/Dialog/PaybrightModal.vue')),
      {
        url,
      },
      {
        showClose: false,
        urlFragment: 'pb-estimate',
        padding: false,
      },
    );
  },

  modalUrl(amount) {
    return `${window['paybrightConfig'].modalUrl}?public_key=${window['paybrightConfig'].key}&purchase_amount=${amount}`;
  },

  preQualifyModalUrl() {
    return `${window['paybrightConfig'].modalUrl}?public_key=${window['paybrightConfig'].key}`;
  },

  async fetchEstimate(amount) {
    try {
      const result = await http.post(
        window['paybrightConfig'].url,
        {
          accountid: window['paybrightConfig'].key,
          amount,
        },
        null,
        {
          credentials: 'same-origin',
        },
      );

      if (result && result.length) {
        return { monthlyPayment: result[0].MonthlyPayment };
      }
    } catch (error) {
      console.error(error);
      return {};
    }
  },
  openPrequalifyModal() {
    return this.openModalForUrl(this.preQualifyModalUrl());
  },
} as IFinancingProvider;